import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getLogisticRoutes(companyId) {
	return dataTransferWrap(
		ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].getLogisticRoutes,
		{
			urlParams: {
				companyId,
			},
		},
	)
}

function getLogisticRoutePreview(companyId, logisticRouteId) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].getLogisticRoutePreview, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
	})
}

function getLogisticRoutePopup(companyId, logisticRouteId) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].getLogisticRoutePopup, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
	})
}

function getLogisticRoute(companyId, logisticRouteId) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].getLogisticRoute, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
	})
}

function createLogisticRoute(companyId, data) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].createLogisticRoute, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function putLogisticRoute(companyId, logisticRouteId, data) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].putLogisticRoute, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
		...data,
	})
}

function patchLogisticRoute(companyId, logisticRouteId, data) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].patchLogisticRoute, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
		...data,
	})
}

function deleteLogisticRoute(companyId, logisticRouteId) {
	return dataTransferWrap(ModulesMap.LOGISTIC_ROUTES,dtConfig[ModulesMap.LOGISTIC_ROUTES].deleteLogisticRoute, {
		urlParams: {
			companyId,
			logisticRouteId,
		},
	})
}

export default {
	getLogisticRoutes,
	getLogisticRoutePreview,
	getLogisticRoutePopup,
	getLogisticRoute,
	createLogisticRoute,
	putLogisticRoute,
	patchLogisticRoute,
	deleteLogisticRoute,
}
